import { useMutation } from '@tanstack/react-query';

import { MutationFunction, useRequest } from '@frontend/api';

export type GetBulkPartFileThumbnailsResponse = {
  thumbnails: Record<string, string>;
};

export type GetBulkPartFileThumbnailsRequestBody = {
  uuids: string[];
};

export const useGetBulkPartFileThumbnails: MutationFunction<
  GetBulkPartFileThumbnailsResponse,
  GetBulkPartFileThumbnailsRequestBody,
  []
> = ({ requestOptions, queryOptions } = {}) => {
  const request = useRequest(requestOptions);

  return useMutation({
    mutationFn: (body) => {
      return request('/parts/files/bulk_thumbnail', {
        init: {
          method: 'POST',
          body,
        },
      });
    },
    ...queryOptions,
    mutationKey: ['getBulkPartFileThumbnails'],
  });
};
